module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style3/cards-style3.component.scss
// module id = ./src/app/features/cards/cards-style3/cards-style3.component.scss
// module chunks = main